import BasePopup from '../Base/BasePopup';

export default BasePopup;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-tree-select@2.1.0@rc-tree-select/es/Popup/MultiplePopup.js
// module id = 780
// module chunks = 0 1